import { APP_TYPE } from '../../enums/appTypes'
import { getAppType } from '../getAppType'
import { DISPLAY_MODE } from './constants'

export const getDisplayMode = () => {
  switch (getAppType()) {
    case APP_TYPE.ANDROID_NATIVE:
      return DISPLAY_MODE.APP_ANDROID
    case APP_TYPE.IOS_NATIVE:
      return DISPLAY_MODE.APP_IOS
    case APP_TYPE.ANDROID_PWA:
      return DISPLAY_MODE.PWA_ANDROID
    case APP_TYPE.IOS_PWA:
      return DISPLAY_MODE.PWA_IOS
    case APP_TYPE.BROWSER_DESKTOP:
    case APP_TYPE.BROWSER_MOBILE:
      return DISPLAY_MODE.BROWSER
  }
}
